import { AcceptFormNames } from '~src/domains/common/enums/common';
import { InputLocalizationType } from '~src/domains/common/types/forms';
import { createDefaultFormMeta, createFormMetaSlice } from '~src/utils/forms';

export type AcceptLocalization = {
  [key: string]: InputLocalizationType;
};

const formMetaDefault = createDefaultFormMeta([
  [AcceptFormNames.CARD_INFO_NUMBER, '', 'secure'],
  [AcceptFormNames.CARD_INFO_EXPIRATION, '', 'secure'],
  [AcceptFormNames.CARD_INFO_CCV, '', 'secure'],
  [AcceptFormNames.BILLING_ZIP, '', 'secure'],
  [AcceptFormNames.CARD_INFO_NAME, ''],
  [AcceptFormNames.FULL_SSN],
  [AcceptFormNames.AUTOPAY, { value: true }],
]);

export const acceptFormSlice = createFormMetaSlice(
  'acceptForm',
  formMetaDefault,
);

export const {
  updateInputValue,
  updateInputHidden,
  updateInputIsValid,
  registerInputLabel,
  registerValidityConfig,
  registerPostProcess,
} = acceptFormSlice.actions;

export default acceptFormSlice.reducer;
